import { Choice } from './choice';
import {TSMap} from 'typescript-map';
import {JsonObject, JsonProperty} from 'json2typescript';
import {TSStringToStringMapConverter} from '../customJsonConverters/TSStringToStringMapConverter';

@JsonObject('Question')
export class Question {

    @JsonProperty('texts',TSStringToStringMapConverter,true)
    texts: TSMap<string,string> = new TSMap();

    @JsonProperty('type',String,true)
    type = '';

    @JsonProperty('validator',String,true)
    validator? = ''; // email, phone, postal code, zip code, numeric, alpha

    @JsonProperty('no',Number,true)
    no = 1;

    @JsonProperty('choices',[Choice],true)
    choices:Choice[] = [];

    @JsonProperty('toSave',Boolean,true)
    toSave =true;

    @JsonProperty('mandatory',Boolean,true)
    mandatory = true;

    @JsonProperty('enabled',Boolean,true)
    enabled = true;

    @JsonProperty('recyclable',Boolean,true)
    recyclable = false;

    @JsonProperty('visible',Boolean,true)
    visible = true;

    @JsonProperty('toSync',Boolean,true)
    toSync = false;

    @JsonProperty('clazz',String,true)
    clazz = '';

    // TODO: review this a question is not supposed to have an answer
    @JsonProperty('answer',String,true)
    answer = '';

    @JsonProperty('toXML',Boolean,true)
    toXML = true;

    @JsonProperty('tag',String,true)
    tag = '';

    constructor() { }

   /* constructor(json?:any) {

      this.texts = new Map();
      this.texts.set('en','');
      if(json!=null) {
        const textos:{[key:string]:string;} = json.texts;
        for(const [key,value]  of Object.entries(textos)) {
          this.texts.set(key,value);
        }
        this.clazz = json.clazz;
        this.toSave = json.toSave;
        this.mandatory = json.mandatory;
        this.recyclable = json.recyclable;
        this.toSync = json.toSync;
        this.visible = json.visible;
        this.enabled = json.enabled;
        this.toXML = json.toXML;
        this.type = json.type;
        this.no = json.no;
        this.tag = json.tag;
        this.choices = new Array<Choice>();
        if (json.choices != null) {
          for(const struct of json.choices) { // (let i = 0; i < json.choices.length; i++) {
            this.choices.push(new Choice(struct));
          }
        }
        this.answer = json.answer;
      }

    }*/

  toJSON() {

    console.log('Calling toJson method');
    return ({
      texts: this.MapToString(),
      type:this.type,
      validator:this.validator, // email, phone, postal code, zip code, numeric, alpha
      no : this.no,
      choices:this.choices,
      toSave :this.toSave,
      mandatory : this.mandatory,
      enabled : this.enabled,
      recyclable : this.recyclable,
      visible : this.visible,
      toSync : this.toSync,
      clazz :this.clazz,
      answer:this.answer,
      toXML:this.toXML,
      tag:this.tag
    });
  }


  private  MapToString() {

    const tmp: {[key:number]:number} = {};

    for(const key of this.texts.keys()) {
      tmp[key] = this.texts.get(key);
    }
    return tmp;
  }


}
